import { TabsBarTab } from '@e3dc-react/shell/Elements/Tabs/TabsBar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useHeaderTabs } from '@e3dc-react/shell/Libs/Header'
import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'

interface UseCompanyDataTabsHook {
  tabs: TabsBarTab[]
  setTabs: (value: TabsBarTab[]) => void
  setActiveTab: (value: number) => void
}

/**
 * Get tab array for Customer Data pages
 * @returns Tabs for current and prospective customers
 */
export const useCompanyDataTabs = (): UseCompanyDataTabsHook => {
  const { setTabs, setActiveTab } = useHeaderTabs()
  const { t } = useCustomTranslation()
  const { id } = useParams<{ id: string }>()

  const tabs = useMemo(
    () => [
      {
        label: t('common.details'),
        href: `/overview/companies/${id}`,
      },
      {
        label: t('user.company.accessRights'),
        href: `/overview/companies/${id}/users`,
      },
      {
        label: t('administration.companies.empl-history.tab'),
        href: `/overview/companies/${id}/history`,
      },
      {
        label: t('administration.companies.installations.tab'),
        href: `/overview/companies/${id}/installations`,
      },
    ],
    [id, t]
  )

  useEffect(() => {
    setTabs(tabs)
    return () => {
      setTabs([])
    }
  }, [tabs, setTabs])

  return { tabs, setTabs, setActiveTab }
}
